import cs from "classnames";
import { ReactElement } from "react";

import { displayCentsWithDollarSign } from "../../../../common/helpers/stringUtils";
import Condition from "../../../../components/Conditional/Condition";
import I18nText from "../../../../components/I18nText/I18nText";
import "./SetItemDisplay.scss";

interface IProps {
	title: string;
	title_cn: string;
	base_price: number;
	price: number;
	is_oos?: boolean;
}

const SetItemDisplay = ({
	title,
	title_cn,
	base_price,
	price,
	is_oos = false,
}: IProps): ReactElement => {
	const price_diff: number = price - base_price;

	return (
		<div className={cs("SetItemDisplay", { "SetItemDisplay--oos": is_oos })}>
			<div className="Label">
				<I18nText enText={title} cnText={title_cn} />
			</div>
			<div className="Price">
				<Condition
					check={price_diff > 0}
				>{`+ ${displayCentsWithDollarSign(price_diff)}`}</Condition>
			</div>
		</div>
	);
};

export default SetItemDisplay;
